import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main/Main'
import ContactUs from '@/components/contact/ContactUs'
import Career from '@/components/contact/Career'
import MessagingApi from '@/components/product/MessagingApi'
import Channels from '@/components/channel/Channels'
import Rbm from '@/components/channel/rbm/Rbm'
import RbmView from '@/components/channel/rbm/RbmView'
import RbmOptIn from '@/components/channel/rbm/RbmOptIn'
import PrivacyNotice from '@/components/legal/PrivacyNotice'
import TermsOfServices from '@/components/legal/TermsOfServices'
import CookiesPolicy from '@/components/legal/CookiesPolicy'
import NotFound from '@/components/NotFound'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Main
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs
    },
    {
      path: '/career', // Not public. If we have it, startupjobs.cz provide ads free of charge.
      name: 'career',
      component: Career
    },
    {
      path: '/product',
      name: 'product',
      component: MessagingApi
    },
    {
      path: '/features',
      redirect: '/product' // to avoid broken links
    },
    {
      path: '/channels',
      name: 'channels',
      component: Channels,
      redirect: { name: 'channels.rbm' },
      children: [
        {
          path: 'rbm',
          name: 'channels.rbm',
          component: RbmView,
          redirect: { name: 'index' },
          children: [
            {
              path: '',
              name: 'index',
              component: Rbm
            },
            {
              path: 'optin',
              name: 'channels.rbm.optin',
              component: RbmOptIn
            }
          ]
        }
      ]
    },
    {
      path: '/privacy-notice',
      name: 'privacyNotice',
      component: PrivacyNotice
    },
    {
      path: '/terms-of-services',
      name: 'termsOfServices',
      component: TermsOfServices
    },
    {
      path: '/cookies',
      name: 'cookiesPolicy',
      component: CookiesPolicy
    },
    {
      path: '*',
      component: NotFound
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  log.debug(`router - beforeEach() - from ${from.fullPath} to ${to.fullPath}`, from, to)
  // Ensures scrolling is enabled across the whole website
  document.body.classList.remove('h-100', 'overflow-hidden')
  return next()
})

export default router
